import { ReviewerOutcome } from "@/backend/models/evidenceSubmission";
import { useRequirementDocumentationStore } from "@/frontend/store/RequirementDocumentationStore";
import { I18n } from "@/i18n/I18n";
import { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

export function ReviewerOutcomeModal({ submissionId, outcome, outcomeLabel, onHide }: {
  submissionId: string;
  outcome: ReviewerOutcome;
  outcomeLabel: string;
  onHide: () => void;
}) {
  const [comment, setComment] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const updateReviewerOutcome = useRequirementDocumentationStore((s) => s.updateReviewerOutcome);

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      await updateReviewerOutcome(submissionId, outcome, comment.trim());
      onHide();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal show onHide={onHide}>
      <Modal.Body>
        <Modal.Title className="pb-3">{outcomeLabel}</Modal.Title>
        <Form>
          <Form.Group>
            <Form.Label className="form-label-neutral">{I18n.get('reviewComment')} ({I18n.get('optional')})</Form.Label>
            <Form.Control
              className="form-control-neutral"
              as="textarea"
              rows={3}
              placeholder={I18n.get('reviewCommentPlaceholder')}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              aria-label={I18n.get('reviewComment')}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn-blue-light fusa-btn-medium" onClick={onHide} disabled={isSubmitting}>
          {I18n.get('cancel')}
        </Button>
        <Button className="fusa-btn-medium fusa-btn-primary" onClick={() => void handleSubmit()} disabled={isSubmitting}>
          {isSubmitting ? I18n.get('saving') : I18n.get('confirmReview')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
